import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Headers } from '@angular/http';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';

declare var $:any;

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
	data_member; statustasks;
	data_complete;
	data_work;
	constructor(private activatedroute: ActivatedRoute, private router: Router, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		let code = this.activatedroute.snapshot.params['code'];
		this.appServices.api('Members/find', {
			'filter': `{"where":{"code": "${code}"}}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.data_member = res[0];
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
		this.appServices.api('Taskxmembers/find', {
			'filter': `{"where":{"deleted":true, "codemember":"${code}"}}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.data_complete = res;
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
		this.appServices.api('Taskxmembers/find', {
			'filter': `{"where":{"deleted":false, "codemember":"${code}"}}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.data_work = res;
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
		this.appServices.api('Taskxmembers/find', {
			'filter': `{"where":{"deleted":false, "codemember":"${code}"}}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			let late = res.filter(function(val){
				return Date.parse(val.task.duedate) - Date.now() < 0;
			})
			obj.component.statustasks = {
				'total': res.length,
				'late': late.length
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}

	imgError(el) {
		el.src = 'https://www.shareicon.net/download/2015/08/14/85196_file_512x512.png'
	}

	save(data) {
		this.appServices.api('Members/save', data, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.notifyService.show(obj.response.statusText)
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	doSignout() {
		this.appServices.headers = new Headers({});
		this.appServices.session = [];
		this.appServices.removeStorage();
		this.router.navigate(['main/home'])
	}
	doReset(data) {
		this.appServices.api('Members/reset', {
			'code': this.data_member.code,
			'pwd': data.pwd,
			'pwd2': data.pwd2
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.notifyService.show(obj.response.statusText);
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	assign(frm, data) {
		$.each(data, function(key){
			frm[key] = data[key];
		});
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/profile/profile.component.ts